import React from 'react';
import './styles.css';
import i18n from '../../translate/i18n';

//COMPONENTS
import Template from '../../components/Template';


export default function Contact() {

  return (
    <Template path={i18n.t<string>('menu.request support')}>
      <div className='container'>
        <div className='container-box col-md-12'>
          <h3>{i18n.t<string>('support.need help?')}</h3>
          <p>{i18n.t<string>('support.contact our support team through the contacts below')}</p>
          <p><strong>E-mail:</strong>  contato@sindicantedigital.com.br</p>
          <p><strong>Abrir solicitação:</strong> <a href='https://suporte.sindicantedigital.com/'>suporte.sindicantedigital.com/</a></p>
        </div>
      </div>
    </Template>
  )
}
